
const MIN_SINGULAR_SHARES_NUM = 1000
export function getSharesNoun(sharesNum: number) {
  let noun = 'shares'
  const str = sharesNum.toString()
  const lastDigit = parseInt(str[str.length - 1], 10)
  if (sharesNum < MIN_SINGULAR_SHARES_NUM && sharesNum !== 11 && lastDigit === 1) {
    noun = 'share'
  }
  return noun
}

export function formatNumber(num: number) {
  const digits = 1
  const units = ['K', 'M', 'B', 'T']
  let decimal

  let i = units.length - 1
  while (i >= 0) {
    decimal = Math.pow(1000, (i + 1))
    if (Math.abs(num) >= decimal) {
      return +(num / decimal).toFixed(digits) + units[i]
    }
    i--
  }
  return num.toString()
}



// WEBPACK FOOTER //
// ./front/apps/shared/javascripts/string_utils.ts